<div class="add-framework">
  <div class="layout" *cygovLoader="saving">
    <div class="header">
      <div class="lato-18-n-vw uppercase header-name">
        Framework Reviewers
      </div>
      <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'"
        (click)="closeModalFunction()">
      </div>
    </div>

    <div class="square-border">
      <div class="left-section">

        <div class="new-user">
          <p class="lato-16-n-vw">Current:</p>
        </div>
        <div class="manager-selection">

          <div class="search" [class.inert-while-loading]="usersLoading">
            <div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
            <input type="text" class="form-control search-input" aria-label="Search"
              placeholder="Search" spellcheck="true" name="search-manager" id="search-manager"
              [disabled]="usersLoading" [(ngModel)]="searchManagerText" (keyup)="searchManager()" />
          </div>

          <div class="users-list" id="users-list">
            <ng-container *ngIf="usersLoading; else usersListContent">
              <div class="user-row user-row-skeleton" *ngFor="let rowWidth of skeletonRows">
                <cygov-skeleton class="checkbox-skeleton" width="calc(1.8 * var(--cvw, 1vw))" height="calc(1.8 * var(--cvh, 1vh))">
                </cygov-skeleton>
                <cygov-skeleton class="avatar-skeleton" shape="circle" width="calc(1.4 * var(--cvw, 1vw))">
                </cygov-skeleton>
                <cygov-skeleton class="username-skeleton" [width]="rowWidth" height="calc(1.4 * var(--cvh, 1vh))">
                </cygov-skeleton>
                <cygov-skeleton class="role-skeleton" width="calc(3 * var(--cvw, 1vw))" height="calc(1.4 * var(--cvh, 1vh))">
                </cygov-skeleton>
              </div>
            </ng-container>

            <ng-template #usersListContent>
              <div *ngFor="let user of filteredUserList, index as i" class="user-row">
                <cygov-checkbox [isChecked]="user.checked" [id]=" 'user-'+(i+1)"
                  (changed)="changeSelectedManager(user, $event, i)" [width]="1.8" [height]="1.8"
                  [useViewPortDimensions]="true">
                </cygov-checkbox>
                <cygov-username-icon [username]="user.name"></cygov-username-icon>
                <div class="lato-14-n-vw username" [ngClass]="{'text-checked': user.checked}">
                  {{user?.name }}
                </div>
                <div class="lato-14-n-vw" [ngClass]="{'text-checked': user.checked}"> &nbsp;|&nbsp;
                  <span *ngIf="user.role === 'mssp'">MSSP</span>
                  <span *ngIf="user.role !== 'mssp'">{{user.role | titlecase}}</span>
                </div>
              </div>
            </ng-template>
          </div>
        </div>

      </div>
      <hr class="horizontal-separator-left-section">

      <div class="archive-footer" [class.inert-while-loading]="usersLoading">
        <cygov-button class="margin-right" [buttonText]="'SAVE'" [buttonWidth]="'calc(5.1 * var(--cvw, 1vw))'" [buttonHeight]="'calc(2.963 * var(--cvh, 1vh))'"
          (click)="addReviewers()">
        </cygov-button>
        <cygov-button class="border" [buttonText]="'CANCEL'" [buttonWidth]="'calc(5.1 * var(--cvw, 1vw))'" [buttonHeight]="'calc(2.963 * var(--cvh, 1vh))'"
          [buttonColor]="'var(--color-btn-cancel-bg)'" [textColor]="'var(--color-text-secondary)'"
          (click)="closeModalFunction()">
        </cygov-button>
      </div>

    </div>

  </div>
</div>
